import React from 'react';
import {Translate} from "../../../services/translate";

export const Badge = () => (
    <div className="calculator-badge">
        <span className="badge">{Translate('calculator_you_save')}</span>
    </div>
);
